import React from "react";
import CustomParagraph from "./CustomParagraph";
import { Flex } from "antd";
import { Link } from "react-router-dom";
import certificationsImage from "../assets/images/Certifications.png";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <CustomParagraph
            text="info@zoomlogi.com"
            fontSize="16px"
            fontWeight="400"
            color="black"
            marginBottom="0"
          />
          <CustomParagraph
            text="2261 Market St, Ste 22649, San Francisco, CA 94114, United States"
            fontSize="16px"
            fontWeight="400"
            color="black"
            marginBottom="24px"
            textAlign="center"
          />
          <div className="footer-links">
            <Link to="/terms-of-service" className="link" title="">
              Terms of Service
            </Link>
            <span className="text-separator">|</span>
            <Link to="/privacy-policy" className="link">
              Privacy
            </Link>
          </div>
          <div className="certifications-container">
            <img src={certificationsImage} alt="Certifications" className="certifications-image" />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
